// extracted by mini-css-extract-plugin
export default {"title1":"VO44jFzhaHio_I33yFNB","infoText":"URvDs89yFFa01l30n2Zn","icon":"PK1pvwyivFCQjkKgnoAG","text":"BYA9hQLlUx43fIQh8N2J","leftIconClass":"SyEqeMRPaF4rtswgJIHQ"};